module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image0.583cb690.jpg";